module.exports = __webpack_public_path__ + "static/media/Students_List.e3d8a732.xlsx";


//////////////////
// WEBPACK FOOTER
// ./src/helpers/Students_List.xlsx
// module id = 763
// module chunks = 81